import React, { FC } from "react";

export type CaRadioProps = {
  disabled?: boolean;
  id?: string;
  name: string;
  value: string;
  onChange?: (vluae: string, e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
};

const CaRadio: FC<CaRadioProps> = ({ disabled, id, name, value, onChange, label }) => {
  return (
    <div className='flex items-center'>
      <input
        id={id}
        name={name}
        type='radio'
        disabled={disabled}
        onChange={(e) => onChange && onChange(value, e)}
        className='w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 focus:ring-2'
      />
      <label htmlFor={id} className='w-full ms-2 text-sm font-medium text-gray-900 '>
        {label}
      </label>
    </div>
  );
};

export default CaRadio;
